import React from "react";
import { useAnimateInView } from "./useAnimateInView";
import { useIcon, normalizeNumbers } from "@SeemplicityDev/shared";
import useSeverityAsPriority, {
  SeverityFieldsEnum,
} from "../../General/useSeverityAsPriority";

interface TopCommonIssuesPageProps {
  data?: {
    categories: {
      name: string;
      issues: {
        name: string;
        source: string;
        subcategory: string;
        severe_count: {
          severity: number;
          count: number;
        };
      }[];
    }[];
  };
}

const TopCommonIssuesPage: React.FC<TopCommonIssuesPageProps> = ({ data }) => {
  const { ref, animateClassNames } = useAnimateInView();
  const { getDataSourceIcon } = useIcon("LIGHT");
  const { getSeverityField } = useSeverityAsPriority();
  return (
    <div
      className={`eoy-page top-common-issues-page ${animateClassNames}`}
      ref={ref}
    >
      <h2 className="page-title">Top 10 Most Common Findings </h2>
      <div className="content-container">
        {data?.categories.map((category, idx) => {
          return (
            <div className="category-container" key={category.name + idx}>
              <span className="category-title">{category.name}</span>
              <div className="subcategories-issues-container">
                {category.issues.map((issue, index) => {
                  return (
                    <div
                      className="subcategory-issue-container"
                      key={issue.name + index + idx}
                    >
                      <span className="issue-subcategory">
                        {issue.subcategory}
                      </span>
                      <div
                        className={`issue-container issue-container-${index + 1}`}
                      >
                        <div className="source-icon-container">
                          <img
                            src={getDataSourceIcon(issue.source, "S") as string}
                            alt={issue.source}
                            className="source-icon"
                          />
                        </div>
                        <div
                          className="severe-count-container"
                          style={{
                            backgroundColor: getSeverityField(
                              issue.severe_count.severity,
                              SeverityFieldsEnum.COLOR
                            ),
                          }}
                        >
                          <span className="count">
                            {normalizeNumbers(issue.severe_count.count)}
                          </span>
                        </div>
                        <span
                          className="issue-name"
                          style={{
                            borderColor: getSeverityField(
                              issue.severe_count.severity,
                              SeverityFieldsEnum.COLOR
                            ),
                          }}
                        >
                          {issue.name}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopCommonIssuesPage;
